export enum SOCKET_WAITER_EVENT {
  /**
   * Event fired when waiters are added to service
   */
  added = 'waiter:added',

  /**
   * Event fired when waiters are removed from service
   */
  removed = 'waiter:removed',
}
